import React, { useState, useEffect } from 'react';
import { Save, X, Tag, FileText } from 'lucide-react';
import Input from '../../components/forms/Input';
import Button from '../../components/ui/Button';

const CategoryForm = ({ categoria, onSubmit, onCancel, isLoading = false, isEdit = false }) => {
    const [formData, setFormData] = useState({
        nombre: '',
        activo: true
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isEdit && categoria) {
            setFormData({
                nombre: categoria.nombre || '',
                activo: categoria.activo !== undefined ? categoria.activo : true
            });
        }
    }, [isEdit, categoria]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        // Limpiar error del campo al modificarlo
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: null
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Validaciones requeridas
        if (!formData.nombre?.trim()) {
            newErrors.nombre = 'El nombre de la categoría es requerido';
        }

        if (formData.nombre && formData.nombre.length < 2) {
            newErrors.nombre = 'El nombre debe tener al menos 2 caracteres';
        }

        if (formData.nombre && formData.nombre.length > 50) {
            newErrors.nombre = 'El nombre no puede exceder 50 caracteres';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        // Preparar datos para envío
        const submitData = {
            ...formData,
            nombre: formData.nombre.trim()
        };

        onSubmit(submitData);
    };

    return (
        <form onSubmit={handleSubmit} className="category-form">
            {/* Información básica */}
            <div className="form-section">
                <h4 className="section-title">
                    <Tag size={18} />
                    Información de la Categoría
                </h4>

                <div className="form-group">
                    <Input
                        label="Nombre de la Categoría *"
                        value={formData.nombre}
                        onChange={(e) => handleInputChange('nombre', e.target.value)}
                        error={errors.nombre}
                        placeholder="Nombre de la categoría"
                        icon={<Tag size={18} />}
                        maxLength={50}
                    />
                </div>

                <div className="form-group">
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={formData.activo}
                            onChange={(e) => handleInputChange('activo', e.target.checked)}
                        />
                        <span className="checkbox-text">Categoría activa</span>
                    </label>
                    <small className="form-help">
                        Las categorías inactivas no aparecerán en los formularios de productos
                    </small>
                </div>
            </div>

            {/* Acciones */}
            <div className="form-actions">
                <Button
                    type="button"
                    variant="outline"
                    onClick={onCancel}
                    disabled={isLoading}
                >
                    <X size={16} />
                    Cancelar
                </Button>

                <Button
                    type="submit"
                    disabled={isLoading}
                >
                    <Save size={16} />
                    {isEdit ? 'Actualizar' : 'Crear'} Categoría
                </Button>
            </div>
        </form>
    );
};

export default CategoryForm;